/** Display and export helpers to reduce PII exposure in the admin UI. */

export const maskAccountNumber = (value) => {
  if (value === null || value === undefined) return "";
  const str = String(value).replace(/\s/g, "");
  if (str.length <= 4) return "****";
  return `${"*".repeat(Math.max(0, str.length - 4))}${str.slice(-4)}`;
};

export const maskPayPalEmail = (email) => {
  if (!email || typeof email !== "string") return "";
  const [local, domain] = email.split("@");
  if (!domain) return "***";
  const visible = local.length <= 2 ? "*" : `${local.slice(0, 2)}***`;
  return `${visible}@${domain}`;
};

const SENSITIVE_USER_KEYS = new Set([
  "password",
  "acctNum",
  "accountNumber",
  "bankAccount",
  "paypalEmail",
  "ssn",
  "bvn",
]);

export const redactUserForExport = (user) => {
  if (!user || typeof user !== "object") return user;
  const copy = { ...user };
  Object.keys(copy).forEach((key) => {
    if (SENSITIVE_USER_KEYS.has(key)) {
      copy[key] = "[redacted]";
    }
  });
  return copy;
};

export const redactWithdrawalForExport = (row) => {
  if (!row || typeof row !== "object") return row;
  return {
    ...row,
    acctNum: row.acctNum ? maskAccountNumber(row.acctNum) : row.acctNum,
    paypalEmail: row.paypalEmail
      ? maskPayPalEmail(row.paypalEmail)
      : row.paypalEmail,
  };
};

export const redactUsersForExport = (users) =>
  Array.isArray(users) ? users.map(redactUserForExport) : [];

export const redactWithdrawalsForExport = (rows) =>
  Array.isArray(rows) ? rows.map(redactWithdrawalForExport) : [];
